/**
 *  WEX Savings Calculator
 *	Code ported from old motorpass theme, needs refactoring, just ignoring lint for now.
 *
 */

/* eslint-disable */

document.addEventListener('DOMContentLoaded', function () {
	const noOfVehiclesInput = document.getElementById('noOfVehicles');
	const errorMessage = document.getElementById('error-message-savings');

	noOfVehiclesInput.addEventListener('input', function () {
		const value = parseInt(noOfVehiclesInput.value, 10);

		if (value > 30) {
			noOfVehiclesInput.value = 30;
			errorMessage.style.display = 'block';
		} else {
			errorMessage.style.display = 'none';
		}
	});

	noOfVehiclesInput.addEventListener('blur', function () {
		errorMessage.style.display = 'none';
	});
});
document.addEventListener('DOMContentLoaded', function () {
	const avgKMsPerVehicleInput = document.getElementById('avgKMsPerVehicle');
	const errorMessage = document.getElementById('error-message-kms');
	const rangeSliderInput = document.querySelector('.range-slider__range'); // Assuming there's only one range slider

	avgKMsPerVehicleInput.addEventListener('input', function () {
		handleInputChange();
	});

	avgKMsPerVehicleInput.addEventListener('blur', function () {
		errorMessage.style.display = 'none';
	});

	function handleInputChange() {
		const value = avgKMsPerVehicleInput.value.replace(/,/g, '');
		let number_int = parseInt(value, 10);

		if (isNaN(number_int)) {
			number_int = 0; // Default to 0 if input is invalid
		}

		if (number_int > 50000) {
			number_int = 50000;
			errorMessage.style.display = 'block';
		} else {
			errorMessage.style.display = 'none';
		}

		formatFieldNumbers(number_int, '#avgKMsPerVehicle');

		// Update the slider value
		rangeSliderInput.value = number_int;
	}

	function formatFieldNumbers(number, target) {
		if (isNaN(number)) {
			number = 0; // Default to 0 if input is invalid
		}
		const formatted_number = number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
		document.querySelector(target).value = formatted_number;
	}

	const rangeSlider = function rangeSlider() {
		const slider = jQuery('.range-slider'),
			range = jQuery('.range-slider__range'),
			value = jQuery('.range-slider__value');

		slider.each(function () {
			value.on('input', function () {
				let number_int = parseInt(jQuery(this).val().replace(/,/g, ''), 10);
				if (isNaN(number_int)) {
					number_int = 0;
				}
				formatFieldNumbers(number_int, '#avgKMsPerVehicle');
				range.val(number_int); // Update the range slider position
			});

			range.on('input', function () {
				let number_int = parseInt(this.value.replace(/,/g, ''), 10);
				if (isNaN(number_int)) {
					number_int = 0;
				}
				formatFieldNumbers(number_int, '#avgKMsPerVehicle');
			});
		});
	};

	rangeSlider(); // Triggered when modal is about to be shown
});

jQuery(function ($) {
	if ($('#frmSavingsCalc').length) {
		$(document).ready(function () {
			savings_calc();
		});
		$('#frmSavingsCalc :input').change(function () {
			savings_calc();
		});
	}

	function savings_calc() {
		const selected_fuel_card_brand = $('select[name=current_fuel_card_brand]').val(); //E5
		console.log('E5: ' + selected_fuel_card_brand);
		const selected_area = $('select[name=selected_area]').val(); //E6
		console.log('E6: ' + selected_area);
		const avg_time_to_fuel = $('input[name=avg_time_to_fuel]').val(); // E7
		console.log('E7 ' + avg_time_to_fuel);
		const avg_litres_per_100km = $('input[name=avg_litres_per_100km]').val(); // E8
		console.log('E8 ' + avg_litres_per_100km);
		const no_of_vehicles = $('input[name=no_of_vehicles]').val(); // E9
		console.log('E9 ' + no_of_vehicles);

		let avg_kms_per_vehicle = $('input[name=avg_kms_per_vehicle]').val();
		avg_kms_per_vehicle = parseInt(avg_kms_per_vehicle.replace(/,/g, ''), 10); // E10
		console.log('E10: ' + avg_kms_per_vehicle);

		const annual_kms_driven_by_fleet = avg_kms_per_vehicle * no_of_vehicles; // E11
		console.log('E11: ' + annual_kms_driven_by_fleet);

		const annual_litres_per_vehicle = (avg_kms_per_vehicle / 100) * avg_litres_per_100km; // E12
		console.log('E12: ' + annual_litres_per_vehicle);

		const annual_litres_purchased =
			annual_litres_per_vehicle * $('input[name=no_of_vehicles]').val(); // E13
		console.log('E13: ' + annual_litres_purchased);

		const avg_fuel_price = $('input[name=avg_fuel_price]').val(); // SET BACK AFTER TESTING // E14
		console.log('E14: ' + avg_fuel_price);

		const current_fuel_card_discount = $('input[name=current_fuel_card_discount]').val(); // E15
		console.log('E15: ' + current_fuel_card_discount);

		const current_annual_fuel_cost = (
			annual_litres_purchased *
			(avg_fuel_price - current_fuel_card_discount)
		).toFixed(2); // E16
		console.log(
			'E16 - CURRENT ANNUAL FUEL COSTS (Specific Branded Card): ' + current_annual_fuel_cost
		);

		// -- Est. Savings with Motorpass ---
		// ------------------------------
		const kms_per_litre = (annual_kms_driven_by_fleet / annual_litres_purchased).toFixed(2); // E17
		console.log('E17: ' + kms_per_litre);

		// -- Curent Diversion costs ---
		// ------------------------------
		const diversion_distances_json = $('input[name=diversion_distances]').val();
		const diversion_distances_obj = $.parseJSON(diversion_distances_json); // E32
		console.log('E32 - json: ' + diversion_distances_json);
		console.log('E32 - obj: ' + diversion_distances_obj);

		let avg_refills_per_week = (annual_litres_per_vehicle / 70 / 52).toFixed(2); // Assumes Avg. Tank Size is 70l // E33
		console.log('E33: ' + avg_refills_per_week);

		let avg_kms_to_find_single_branded = (
			diversion_distances_obj[selected_fuel_card_brand][selected_area] * 1.5
		).toFixed(2); // E34
		console.log('E34: ' + avg_kms_to_find_single_branded);

		const avg_cost_per_km = (current_annual_fuel_cost / annual_kms_driven_by_fleet).toFixed(2); // E35
		console.log('DEBUG: ' + current_annual_fuel_cost);
		console.log('DEBUG: ' + annual_kms_driven_by_fleet);
		console.log('E35: ' + avg_cost_per_km);

		const est_diversion_costs_refuel = (
			avg_kms_to_find_single_branded * avg_cost_per_km
		).toFixed(2); // E36
		console.log('E36: ' + est_diversion_costs_refuel);

		const est_diversion_costs_refuel_pweek = (
			avg_refills_per_week * est_diversion_costs_refuel
		).toFixed(2); // E37
		console.log('E37: ' + est_diversion_costs_refuel_pweek);

		const est_diversion_costs_annual_vehicle = (52 * est_diversion_costs_refuel_pweek).toFixed(
			2
		); // E38
		console.log('E38: ' + est_diversion_costs_annual_vehicle);

		const est_diversion_costs_refuel_fleet = (
			est_diversion_costs_refuel * no_of_vehicles
		).toFixed(2); // E39
		console.log('E39: ' + est_diversion_costs_refuel_fleet);

		const est_diversion_costs_refuel_pweek_fleet = (
			est_diversion_costs_refuel_pweek * no_of_vehicles
		).toFixed(2); // E40
		console.log('E40: ' + est_diversion_costs_refuel_pweek_fleet);

		const est_diversion_costs_annual_fleet = (
			est_diversion_costs_annual_vehicle * no_of_vehicles
		).toFixed(2); // E41
		console.log(
			'E41 - EST. ANNUAL DIVERSION COSTS  (for fleet): ' + est_diversion_costs_annual_fleet
		);
		// -- Future Diversion costs (w/ Motorpass) ---
		// ------------------------------

		var avg_kms_to_find_station = diversion_distances_obj['All Brands'][selected_area]; // E42
		console.log('E42: ' + avg_kms_to_find_station);

		// -- Est. Savings with Motorpass (cont.) ---
		// ------------------------------

		const kms_saved_per_trip_no_divert = (
			avg_kms_to_find_single_branded - avg_kms_to_find_station
		).toFixed(2); // (calc E33-E43)
		console.log('E33-E43: ' + kms_saved_per_trip_no_divert);

		const kms_saved_per_week_no_divert = (
			avg_refills_per_week * kms_saved_per_trip_no_divert
		).toFixed(2); // E20
		console.log('E20: ' + kms_saved_per_week_no_divert);

		const kms_saved_per_year_no_divert = (kms_saved_per_week_no_divert * 52).toFixed(2); // E21
		console.log('E21: ' + kms_saved_per_year_no_divert);

		const litres_saved_per_year_no_divert = (
			kms_saved_per_year_no_divert / kms_per_litre
		).toFixed(2); // E22
		console.log('E22: ' + litres_saved_per_year_no_divert);

		const litres_saved_per_year_no_divert_fleet = (
			litres_saved_per_year_no_divert * no_of_vehicles
		).toFixed(2); // E23
		console.log('E23: ' + litres_saved_per_year_no_divert_fleet);

		const est_future_annual_kms_fleet = (
			(avg_kms_per_vehicle - kms_saved_per_year_no_divert) *
			no_of_vehicles
		).toFixed(2); // E24
		console.log('E24: ' + est_future_annual_kms_fleet);

		const est_annual_fuel_req_fleet = (
			annual_litres_purchased - litres_saved_per_year_no_divert_fleet
		).toFixed(2); // E25
		console.log('E25: ' + est_annual_fuel_req_fleet);

		const savings_per_ltr_motorpass = $('input[name=savings_per_ltr_motorpass]').val(); // E26
		console.log('E26: ' + savings_per_ltr_motorpass);

		const est_fuel_pruchase_price_motorpass = avg_fuel_price - savings_per_ltr_motorpass; // E27
		console.log('E27: ' + est_fuel_pruchase_price_motorpass);

		const est_annual_fuel_cost_motorpass = (
			est_annual_fuel_req_fleet * est_fuel_pruchase_price_motorpass
		).toFixed(2); // E28
		console.log(
			'E28 - EST. future annual fuel cost using Motorpass: ' + est_annual_fuel_cost_motorpass
		);

		// -- Future Diversion costs (w/ Motorpass) - Cont. ---
		// ------------------------------
		const est_annual_savings_motorpass = (
			current_annual_fuel_cost - est_annual_fuel_cost_motorpass
		).toFixed(2); // E44
		console.log('E44: ' + est_annual_savings_motorpass);

		const avg_cost_per_kms = (
			est_annual_fuel_cost_motorpass / est_future_annual_kms_fleet
		).toFixed(2); // E45
		console.log('E45: ' + avg_cost_per_kms);

		const est_future_diversion_costs_refuel = (
			avg_kms_to_find_station * avg_cost_per_kms
		).toFixed(2); // E46
		console.log('E46: ' + est_future_diversion_costs_refuel);

		const est_future_diversion_costs_refuel_pweek = (
			avg_refills_per_week * est_future_diversion_costs_refuel
		).toFixed(2); // E47
		console.log('E47: ' + est_future_diversion_costs_refuel_pweek);

		const est_future_diversion_costs_annual = (
			52 * est_future_diversion_costs_refuel_pweek
		).toFixed(2); // E48
		console.log('E48: ' + est_future_diversion_costs_annual);

		const est_future_diversion_costs_refuel_fleet = (
			est_future_diversion_costs_refuel * no_of_vehicles
		).toFixed(2); // E49
		console.log('E49: ' + est_future_diversion_costs_refuel_fleet);

		const est_future_diversion_costs_pweek_fleet = (
			est_future_diversion_costs_refuel_pweek * no_of_vehicles
		).toFixed(2); // E50
		console.log('E50: ' + est_future_diversion_costs_pweek_fleet);

		const est_future_diversion_costs_annual_fleet = (
			est_future_diversion_costs_annual * no_of_vehicles
		).toFixed(2); // E51
		console.log('E51: ' + est_future_diversion_costs_annual_fleet);

		const est_future_savings_reducing_diversion = (
			est_diversion_costs_annual_fleet - est_future_diversion_costs_annual_fleet
		).toFixed(2); // E52
		console.log('E52: ' + est_future_savings_reducing_diversion);

		let est_future_fuel_savings_reducing_diversion = (
			est_annual_savings_motorpass - est_future_savings_reducing_diversion
		).toFixed(2); // E53
		if (est_future_fuel_savings_reducing_diversion < 0) {
			est_future_fuel_savings_reducing_diversion = 0;
		}
		console.log('E53: ' + est_future_fuel_savings_reducing_diversion);

		// -- Current estimated labour costs associated with refuelling vehicles ---
		// ------------------------------

		const ave_annual_wage_driver = $('input[name=ave_annual_wage_driver]').val(); // E57
		console.log('E57: ' + ave_annual_wage_driver);

		const ave_hourly_wage_driver = (ave_annual_wage_driver / (52 * 38)).toFixed(2); // 38hr working week // E58
		console.log('E58: ' + ave_hourly_wage_driver);

		avg_refills_per_week = avg_refills_per_week; // same as E32 // E59
		console.log('E58: ' + avg_refills_per_week);

		const avg_time_to_refill = 10; // E61
		console.log('E61: ' + avg_time_to_refill);

		avg_kms_to_find_single_branded = avg_kms_to_find_single_branded; // same as E33 // E63
		console.log('E63: ' + avg_kms_to_find_single_branded);

		var avg_time_to_refill_per_driver = (avg_time_to_refill / 60).toFixed(2); // E64
		console.log('E64: ' + avg_time_to_refill_per_driver);

		var est_labour_cost_to_refill = (
			avg_time_to_refill_per_driver * ave_hourly_wage_driver
		).toFixed(2); // E65
		console.log('E65: ' + est_labour_cost_to_refill);

		const est_labour_cost_to_refill_pweek = (
			est_labour_cost_to_refill * avg_refills_per_week
		).toFixed(2); // E66
		console.log('E66: ' + est_labour_cost_to_refill_pweek);

		var est_labour_cost_to_refill_pvehicle = (est_labour_cost_to_refill_pweek * 52).toFixed(2); // E67
		console.log('E67: ' + est_labour_cost_to_refill_pvehicle);

		const est_labour_cost_to_refill_fleet = (
			est_labour_cost_to_refill * no_of_vehicles
		).toFixed(2); // E68
		console.log('E68: ' + est_labour_cost_to_refill_fleet);

		const est_labour_cost_to_refill_pweek_fleet = (
			est_labour_cost_to_refill_pweek * no_of_vehicles
		).toFixed(2); // E69
		console.log('E69: ' + est_labour_cost_to_refill_pweek_fleet);

		const est_annual_labour_cost_fleet = (
			est_labour_cost_to_refill_pvehicle * no_of_vehicles
		).toFixed(2); // E71
		console.log('E71: ' + est_annual_labour_cost_fleet);

		let avg_driver_diversion_time_mins = avg_kms_to_find_single_branded; // E72
		if (selected_area.indexOf('Metro') >= 0) {
			avg_driver_diversion_time_mins = (avg_driver_diversion_time_mins / (30 / 60)).toFixed(
				2
			);
		} else {
			avg_driver_diversion_time_mins = (avg_driver_diversion_time_mins / (40 / 60)).toFixed(
				2
			);
		}
		console.log('E72: ' + avg_driver_diversion_time_mins);

		const additional_labour_cost_diversion_prefuel = (
			(avg_driver_diversion_time_mins / 60) *
			ave_hourly_wage_driver
		).toFixed(2); // E73
		console.log('E73: ' + additional_labour_cost_diversion_prefuel);

		const additional_labour_cost_diversion_pweek = (
			additional_labour_cost_diversion_prefuel * avg_refills_per_week
		).toFixed(2); // E74
		console.log('E74: ' + additional_labour_cost_diversion_pweek);

		const additional_labour_cost_diversion_annual = (
			additional_labour_cost_diversion_pweek * 52
		).toFixed(2); // E75
		console.log('E75: ' + additional_labour_cost_diversion_annual);

		const additional_labour_cost_diversion_fleet = (
			additional_labour_cost_diversion_prefuel * no_of_vehicles
		).toFixed(2); // E76
		console.log('E76: ' + additional_labour_cost_diversion_fleet);

		const additional_labour_cost_diversion_pweek_fleet = (
			additional_labour_cost_diversion_pweek * no_of_vehicles
		).toFixed(2); // E77
		console.log('E77: ' + additional_labour_cost_diversion_pweek_fleet);

		const additional_annual_labour_cost_fleet = (
			additional_labour_cost_diversion_annual * no_of_vehicles
		).toFixed(2); // E79
		console.log('E79: ' + additional_annual_labour_cost_fleet);

		const total_annual_cost_for_refuel =
			parseInt(additional_annual_labour_cost_fleet) + parseInt(est_annual_labour_cost_fleet); //additional_annual_labour_cost_fleet.toFixed(2) + (est_annual_labour_cost_fleet).toFixed(2); // E80
		console.log(
			'E80 - TOTAL. ANNUAL REFUEL COSTS  (for fleet): ' + total_annual_cost_for_refuel
		);

		const total_annual_hrs_for_refuel = (
			total_annual_cost_for_refuel / ave_hourly_wage_driver
		).toFixed(2); // E81
		console.log('E81 - TOTAL. ANNUAL REFUEL HRS  (for fleet): ' + total_annual_hrs_for_refuel);

		// -- Future estimated labour costs associated with refuelling vehicles using 'motorpass'
		// ------------------------------
		var avg_time_to_refill_per_driver = avg_time_to_refill_per_driver; // same as E63
		console.log('E83: ' + avg_time_to_refill_per_driver);

		var est_labour_cost_to_refill = est_labour_cost_to_refill; // same as E64
		console.log('E85: ' + est_labour_cost_to_refill);

		var est_labour_cost_to_refill_pvehicle = (
			est_labour_cost_to_refill * avg_refills_per_week
		).toFixed(2); // E86
		console.log('E86: ' + est_labour_cost_to_refill_pvehicle);

		const est_labour_cost_annual_pvehicle = (est_labour_cost_to_refill_pvehicle * 52).toFixed(
			2
		); // E87
		console.log('E87: ' + est_labour_cost_annual_pvehicle);

		const est_labour_cost_to_refill_pfleet = (
			est_labour_cost_to_refill * no_of_vehicles
		).toFixed(2); // E88
		console.log('E88: ' + est_labour_cost_to_refill_pfleet);

		const est_labour_cost_to_refill_pweek_pfleet = (
			est_labour_cost_to_refill_pvehicle * no_of_vehicles
		).toFixed(2); // E89
		console.log('E89: ' + est_labour_cost_to_refill_pweek_pfleet);

		const est_labour_cost_annual_pfleet = (
			est_labour_cost_annual_pvehicle * no_of_vehicles
		).toFixed(2); // E92
		console.log('E92: ' + est_labour_cost_annual_pfleet);

		var avg_kms_to_find_station = avg_kms_to_find_station; // same as E43 // E93
		console.log('E93: ' + avg_kms_to_find_station);

		const avg_divesion_time_motorpass = (avg_kms_to_find_station / (40 / 60)).toFixed(2); // E94
		console.log('E94: ' + avg_divesion_time_motorpass);

		const labour_cost_diverion_motorpass = (
			(avg_divesion_time_motorpass / 60) *
			ave_hourly_wage_driver
		).toFixed(2); // E95
		console.log('E95: ' + labour_cost_diverion_motorpass);

		const labour_cost_diverion_pweek_motorpass = (
			labour_cost_diverion_motorpass * avg_refills_per_week
		).toFixed(2); // E96
		console.log('E96: ' + labour_cost_diverion_pweek_motorpass);

		const labour_cost_annual_pvehicle_motorpass = (
			labour_cost_diverion_pweek_motorpass * 52
		).toFixed(2); // E97
		console.log('E97: ' + labour_cost_annual_pvehicle_motorpass);

		const avg_divesion_time_fleet_motorpass = (
			labour_cost_diverion_motorpass * no_of_vehicles
		).toFixed(2); // E98
		console.log('E98: ' + avg_divesion_time_fleet_motorpass);

		const avg_divesion_time_pweek_fleet_motorpass = (
			labour_cost_diverion_pweek_motorpass * no_of_vehicles
		).toFixed(2); // E99
		console.log('E99: ' + avg_divesion_time_pweek_fleet_motorpass);

		const avg_divesion_cost_anuual_fleet_motorpass = (
			labour_cost_annual_pvehicle_motorpass * no_of_vehicles
		).toFixed(2); // E101
		console.log('E101: ' + avg_divesion_cost_anuual_fleet_motorpass);

		const total_annual_labour_cost_fleet_motorpass =
			parseInt(avg_divesion_cost_anuual_fleet_motorpass) +
			parseInt(est_labour_cost_annual_pfleet); // E102
		console.log('E102: ' + total_annual_labour_cost_fleet_motorpass);

		const total_annual_labour_hrs_fleet_motorpass = (
			total_annual_labour_cost_fleet_motorpass / ave_hourly_wage_driver
		).toFixed(2); // E104
		console.log('E104: ' + total_annual_labour_hrs_fleet_motorpass);

		const total_est_labour_savings_motorpass =
			parseInt(total_annual_cost_for_refuel) -
			parseInt(total_annual_labour_cost_fleet_motorpass); // E105
		console.log('E105: ' + total_est_labour_savings_motorpass);

		// -- Current estimated administration support costs associated with fuel repayments or reimbursements
		// ------------------------------
		// E108

		const mthly_fuel_repayments = 1; // E109
		console.log('E109: ' + mthly_fuel_repayments);

		var cost_of_motorpass_repayments = $('input[name=cost_of_motorpass_repayments]').val(); // E110
		console.log('E110: ' + cost_of_motorpass_repayments);

		var admin_cost_of_motorpass_repayments = (
			mthly_fuel_repayments * cost_of_motorpass_repayments
		).toFixed(2); // E111
		console.log('E111: ' + admin_cost_of_motorpass_repayments);

		var admin_cost_of_motorpass_annual = (admin_cost_of_motorpass_repayments * 12).toFixed(2); // E112
		console.log('E112: ' + admin_cost_of_motorpass_annual);

		// -- Future estimated administration support costs associated with fuel repayments or reimbursements
		// ------------------------------

		const mthly_fuel_repayments_motorpass = 1; // E115
		console.log('E115: ' + mthly_fuel_repayments_motorpass);

		var cost_of_motorpass_repayments = cost_of_motorpass_repayments; // Same as E109 // E116
		console.log('E116: ' + cost_of_motorpass_repayments);

		var admin_cost_of_motorpass_repayments = admin_cost_of_motorpass_repayments; // Same as E110 // E117
		console.log('E117: ' + admin_cost_of_motorpass_repayments);

		var admin_cost_of_motorpass_annual = admin_cost_of_motorpass_annual; // Same as E111 // E119
		console.log('E119: ' + admin_cost_of_motorpass_annual);

		const est_admin_savings_with_motopass =
			admin_cost_of_motorpass_annual - admin_cost_of_motorpass_annual; // E120
		console.log('E120: ' + est_admin_savings_with_motopass);

		const total_current_est_costs =
			parseInt(current_annual_fuel_cost) +
			parseInt(total_annual_cost_for_refuel) +
			parseInt(admin_cost_of_motorpass_annual); // E124
		console.log('E124 - TOTAL. COSTS TO REFUEL : ' + total_current_est_costs);

		const total_future_est_costs =
			parseInt(est_annual_fuel_cost_motorpass) +
			parseInt(total_annual_labour_cost_fleet_motorpass) +
			parseInt(admin_cost_of_motorpass_annual); // E125
		console.log('E125 - TOTAL. FUTURE COSTS TO REFUEL : ' + total_future_est_costs);

		let total_est_savings = total_current_est_costs - total_future_est_costs;
		if (total_est_savings < 0) {
			total_est_savings = 0;
		}
		console.log('-----------------------------');
		console.log('TOTAL. EST. SAVINGS : ' + total_est_savings);
		console.log('-----------------------------');

		let total_est_hours_saved =
			parseInt(total_annual_hrs_for_refuel) -
			parseInt(total_annual_labour_hrs_fleet_motorpass);
		if (total_est_hours_saved < 0) {
			total_est_hours_saved = 0;
		}
		console.log('-----------------------------');
		console.log('TOTAL. EST. HOURS SAVED : ' + total_est_hours_saved);
		console.log('-----------------------------');

		// Format the savings and hours saved values
		total_est_savings = total_est_savings.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
		total_est_hours_saved = total_est_hours_saved
			.toString()
			.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

		// Check if savings exceed $3,000
		if (parseFloat(total_est_savings.replace(/,/g, '')) > 3000) {
			$('#estSavings').html('$3,000+');
			$('#savingsMessage').html('Contact us for a customized deal');
		} else {
			$('#estSavings').html('$' + total_est_savings);
			$('#savingsMessage').html(''); // Clear the message if savings are less than $3,000
		}

		// Update the HTML for hours saved as well
		// Condition for "All Brands"
		if (selected_fuel_card_brand === 'FleetCard') {
			$('#saving-headline').html('Save more than');
			$('#saving-details').html('per transaction fee! (non-Coles Express & Shell sites)');
			$('#estSavings').html('$2');
			$('#estHoursSavings').html('0 hours');
		} else {
			$('#saving-headline').html('Save');
			$('#saving-details').html('per year');
			$('#estHoursSaved').html(total_est_hours_saved);

			$('#estHoursSavings').html(total_est_hours_saved + ' hours');
		}
	}

	$('#modalSavingsReport').on('show.bs.modal', function (e) {
		const no_of_vehicles = $('input[name=no_of_vehicles]').val();
		$(e.currentTarget).find('input[name="input_6"]').val(no_of_vehicles);
		const selected_area = $('select[name=selected_area]').val();
		$(e.currentTarget).find('input[name="input_7"]').val(selected_area);
		const avg_kms_per_vehicle = $('input[name=avg_kms_per_vehicle]').val();
		$(e.currentTarget).find('input[name="input_8"]').val(avg_kms_per_vehicle);
		const selected_fuel_card_brand = $('select[name=current_fuel_card_brand]').val();
		$(e.currentTarget).find('input[name="input_9"]').val(selected_fuel_card_brand);
		const current_fuel_card_discount = $('input[name=current_fuel_card_discount]').val();
		$(e.currentTarget).find('input[name="input_10"]').val(current_fuel_card_discount);
		$(e.currentTarget).find('input[name="input_11"]').val($('#estSavings').html());
		$(e.currentTarget).find('input[name="input_12"]').val($('#estHoursSavings').html());
	});
	('use strict');
});
